import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isHome && !scrolled
          ? 'bg-transparent'
          : 'bg-background-50/95 backdrop-blur-md border-b border-background-200'
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group whitespace-nowrap">
            <span className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold transition-colors ${
              isHome && !scrolled
                ? 'bg-white/20 text-white'
                : 'bg-primary-500 text-background-50'
            }`}>法</span>
            <span className={`font-heading font-semibold text-sm transition-colors ${
              isHome && !scrolled ? 'text-white' : 'text-foreground-950'
            }`}>强奸罪法律解析与辩护指南</span>
          </Link>

          <div className="hidden lg:flex items-center gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-3 py-2 rounded-md text-sm whitespace-nowrap transition-colors ${
                  isHome && !scrolled
                    ? 'text-white/80 hover:text-white hover:bg-white/10'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                } ${location.pathname === `/category/${cat.slug}` ? (isHome && !scrolled ? 'text-white bg-white/15' : 'text-primary-600 bg-primary-50') : ''}`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors ml-2 ${
                isHome && !scrolled
                  ? 'bg-white text-foreground-950 hover:bg-white/90'
                  : 'bg-primary-500 text-background-50 hover:bg-primary-600'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
              isHome && !scrolled ? 'text-white hover:bg-white/10' : 'text-foreground-700 hover:bg-background-100'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="lg:hidden border-t border-background-200 bg-background-50 pb-4">
            <div className="flex flex-col gap-1 pt-3 px-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-3 py-2.5 rounded-md text-sm whitespace-nowrap transition-colors ${
                    location.pathname === `/category/${cat.slug}`
                      ? 'text-primary-600 bg-primary-50 font-medium'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                className="px-3 py-2.5 rounded-md text-sm font-medium text-primary-600 hover:bg-primary-50 whitespace-nowrap transition-colors mt-1"
              >
                关于我们
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}